import { Box, Text } from '@wix/design-system';
import { usePremiumCurrencyFormatter, } from '@wix/premium-react-text';
import classNames from 'classnames';
import React from 'react';
import { DisplayPrice, InlineDisplayPrice } from './DisplayPrice';
import priceDataHooks from './Price.datahooks';
import s from './Price.scss';
import { TaxIncludedLabel } from './TaxIncludedLabel/TaxIncludedLabel';
const getCurrencyPartByType = (partType, parts) => {
    const part = parts.find((p) => p.type === partType)?.value ?? '';
    if (!part) {
        // TODO: throw exception
    }
    return part;
};
export const Price = ({ size, price, fullPrice, cycleLabel, taxIncludedLabel, shouldShowTaxIncludedLabel, shouldShowProductFullPrice, shouldBreakLine, inline, light, savings, }) => {
    const [formatCurrency, formatCurrencyToParts] = usePremiumCurrencyFormatter();
    const isProductDiscounted = Math.abs(fullPrice - price) < 0.01; // This check prevents JS rounding errors
    const parts = formatCurrencyToParts(price, { asSingleIntegerString: true });
    const partTypes = ['currency', 'integer', 'fraction'];
    const [currencyLabel, integer, fraction] = partTypes.map((partType) => getCurrencyPartByType(partType, parts));
    return (React.createElement(Box, { direction: "vertical", className: classNames(s.priceContainer, s[size]), dataHook: priceDataHooks.container },
        inline ? (React.createElement(InlineDisplayPrice, { size: size, light: light, priceLabel: formatCurrency(price, { hideZeroDecimals: true }), cycleLabel: cycleLabel, fullPriceLabel: formatCurrency(fullPrice, { hideZeroDecimals: true }), shouldShowProductFullPrice: shouldShowProductFullPrice, shouldBreakLine: shouldBreakLine })) : (React.createElement(DisplayPrice, { size: size, integer: integer, fraction: fraction, currency: currencyLabel, cycleLabel: cycleLabel })),
        shouldShowProductFullPrice && !inline && (React.createElement(Box, { align: "center" },
            React.createElement(Text, { dataHook: priceDataHooks.fullPrice, size: "medium", className: classNames(s.fullPrice, {
                    [s.hidden]: isProductDiscounted,
                    [s.light]: light,
                }) }, formatCurrency(fullPrice)))),
        savings,
        shouldShowTaxIncludedLabel && (React.createElement(TaxIncludedLabel, { inline: inline, dataHook: priceDataHooks.taxNote, className: classNames(s.taxNote), size: size }, taxIncludedLabel))));
};
//# sourceMappingURL=Price.js.map